import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

const EditDeleteButtons = ({ items }) => {
  // Ensure 'Delete' always appears before 'Edit'
  const orderedItems = [...items].sort((a, b) => {
    if (a.label === 'Delete') return -1;
    if (b.label === 'Delete') return 1;
    return 0;
  });

  return (
    <div className="flex gap-4 justify-end">
      {orderedItems.map((item) => (
        <Button
          key={item.label}
          label={item.label}
          aria-label={`${item.label} item`}
          onClick={item.onClick}
          color={item.label === 'Delete' ? 'secondary' : 'primary'}
          size="md"
        />
      ))}
    </div>
  );
};

EditDeleteButtons.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })).isRequired,
};

export default EditDeleteButtons;
